import { colors } from "../colors"

import { fonts } from "./fonts"

const fontFamily = `${fonts.zen.name}, ${fonts.zen.fallbacks.join(", ")}` as const

// In order to override the text colors of a certain part of the application,
// use the css variables exported in the textColorVariables object.
// Example using styled components:
//
// import { textColorVariables } from "@izettle/otto"
//
// const DarkThemeSection = styled.div`
//   background: black;
//   ${textColorVariables.primary}: white;
//   ${textColorVariables.secondary}: lightgrey;
// `
//
// All descendants of the DarkThemeSection that use the tokens provided here
// will subsequently be white and lightgrey.

export const textColorVariables = {
  primary: "--text-color-primary",
  secondary: "--text-color-secondary",
} as const

export const typography = {
  huge: `
    font: ${fonts.zen.fonts.semiBold.weight} 48px/56px ${fontFamily};
    letter-spacing: -0.9px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  title1: `
    font: ${fonts.zen.fonts.semiBold.weight} 32px/40px ${fontFamily};
    letter-spacing: -0.4px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  title2: `
    font: ${fonts.zen.fonts.semiBold.weight} 24px/32px ${fontFamily};
    letter-spacing: -0.2px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  large: `
    font: ${fonts.zen.fonts.regular.weight} 20px/28px ${fontFamily};
    letter-spacing: -0.1px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  largeBold: `
    font: ${fonts.zen.fonts.semiBold.weight} 20px/28px ${fontFamily};
    letter-spacing: -0.1px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  largeSecondary: `
    font: ${fonts.zen.fonts.semiBold.weight} 20px/28px ${fontFamily};
    letter-spacing: -0.1px;
    color: ${colors.text.secondary};
    color: var(${textColorVariables.secondary}, ${colors.text.secondary});
  `,
  regular: `
    font: ${fonts.zen.fonts.regular.weight} 16px/24px ${fontFamily};
    letter-spacing: 0px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  regularBold: `
    font: ${fonts.zen.fonts.semiBold.weight} 16px/24px ${fontFamily};
    letter-spacing: 0px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
    `,
  regularSecondary: `
    font: ${fonts.zen.fonts.regular.weight} 16px/24px ${fontFamily};
    letter-spacing: 0px;
    color: ${colors.text.secondary};
    color: var(${textColorVariables.secondary}, ${colors.text.secondary});
  `,
  regularLongText: `
    font: ${fonts.zen.fonts.regular.weight} 16px/24px ${fontFamily};
    letter-spacing: 0px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  small: `
    font: ${fonts.zen.fonts.regular.weight} 14px/20px ${fontFamily};
    letter-spacing: 0.2px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  smallBold: `
    font: ${fonts.zen.fonts.semiBold.weight} 14px/20px ${fontFamily};
    letter-spacing: 0.2px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
    `,
  smallSecondary: `
    font: ${fonts.zen.fonts.regular.weight} 14px/20px ${fontFamily};
    letter-spacing: 0.2px;
    color: ${colors.text.secondary};
    color: var(${textColorVariables.secondary}, ${colors.text.secondary});
  `,
  smallCaps: `
    font: ${fonts.zen.fonts.semiBold.weight} 14px/16px ${fontFamily};
    letter-spacing: 0.6px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
    text-transform: uppercase;
  `,
  smallCapsSecondary: `
    font: ${fonts.zen.fonts.semiBold.weight} 14px/16px ${fontFamily};
    letter-spacing: 0.6px;
    color: ${colors.text.secondary};
    color: var(${textColorVariables.secondary}, ${colors.text.secondary});
    text-transform: uppercase;
  `,
  mini: `
    font: ${fonts.zen.fonts.regular.weight} 12px/16px ${fontFamily};
    letter-spacing: 0.3px;
    color: ${colors.text.default};
    color: var(${textColorVariables.primary}, ${colors.text.default});
  `,
  miniSecondary: `
    font: ${fonts.zen.fonts.semiBold.weight} 12px/16px ${fontFamily};
    letter-spacing: 0.3px;
    color: ${colors.text.secondary};
    color: var(${textColorVariables.secondary}, ${colors.text.secondary});
  `,
} as const
